import { useFeatureIsOn } from "@growthbook/growthbook-react";

export default function useIsUploadsEnabled() {
	return useFeatureIsOn("meeting-recording-uploads");
}
